import { Theme } from '@material-ui/core/styles';

const MuiSwitch = (theme: Theme) => {
    const backgroundColor = theme.palette.type === 'light' ? theme.palette.grey[200] : theme.palette.grey[700];

    return {
        /* Styles applied to the root element. */
        root: {
            width: 46 + 12 * 2,
            height: 14 + 12 * 2,
            padding: '6px 12px',
        },
        /* Styles applied to the root element if `size="small"`. */
        sizeSmall: {
            width: 28 + 12 * 2,
            height: 4 + 12 * 2,
            padding: '6px 12px',
            '& $thumb': {
                width: 12,
                height: 12,
            },
            '& $switchBase': {
                margin: '0 6px',
                padding: 8,
                '&$checked': {
                    transform: 'translateX(12px)',
                },
            },
        },
        /* Styles applied to the root element if `edge="start"`. */
        edgeStart: {
            marginLeft: -12,
        },
        /* Styles applied to the root element if `edge="end"`. */
        edgeEnd: {
            marginRight: -12,
        },
        /* Styles applied to the internal `SwitchBase` component's `root` class. */
        switchBase: {
            margin: '0 6px',
            '&$checked': {
                transform: 'translateX(20px)',
            },
        },
        /* Styles applied to the track element. */
        track: {
            backgroundColor,
            border: `2px solid ${theme.palette.grey[400]}`,
            borderRadius: 20,
            opacity: 1,
            transition: theme.transitions.create(['background-color', 'border']),
        },
        /* Styles applied to the internal SwitchBase component's root element if `color="primary"`. */
        colorPrimary: {
            '&$checked': {
                color: theme.palette.primary.main,
            },
            '&$disabled': {
                color: theme.palette.grey[400],
            },
            '&$checked + $track': {
                backgroundColor,
                opacity: 1,
            },
            '&$disabled + $track': {
                backgroundColor: theme.palette.action.disabledBackground,
                borderColor: 'transparent',
            },
        },
        /* Styles applied to the internal SwitchBase component's root element if `color="secondary"`. */
        colorSecondary: {
            '&$checked': {
                color: theme.palette.secondary.main,
            },
            '&$disabled': {
                color: theme.palette.grey[400],
            },
            '&$checked + $track': {
                backgroundColor,
                opacity: 1,
            },
            '&$disabled + $track': {
                backgroundColor: theme.palette.action.disabledBackground,
                borderColor: 'transparent',
            },
        },
    };
};

export default MuiSwitch;
